// Generated by ReScript, PLEASE EDIT WITH CARE


var bankTransferList = [
  "sepa_bank_transfer",
  "instant_bank_transfer",
  "instant_bank_transfer_finland",
  "instant_bank_transfer_poland"
];

export {
  bankTransferList ,
}
/* No side effect */
